module.exports = __webpack_public_path__ + "static/media/form_checklist_okb.288ce8a5.jpg";